module.exports = __webpack_public_path__ + "static/media/linkedin.eaf1ea22.svg";